import React from 'react';

/**
 * UIButton - Button atom component
 */
const UIButton = ({
    label = 'Button',
    variant = 'primary',
    disabled = false,
    state = 'default',
    deviceType = 'mobile',
    tokens
}) => {
    // Get colors from tokens or use defaults
    const primaryColor = tokens?.colors?.find(c => c.name === 'primary')?.value || '#1677ff';
    const secondaryColor = tokens?.colors?.find(c => c.name === 'secondary')?.value || '#6366f1';

    // Get typography from tokens - use 'button' or 'body' style
    const buttonTypo = tokens?.typography?.find(t => t.name === 'button')
        || tokens?.typography?.find(t => t.name === 'body')
        || { fontFamily: 'Inter, system-ui, sans-serif', weight: 500, sizes: { mobile: 14, tablet: 14, desktop: 14 } };

    const fontSize = buttonTypo.sizes?.[deviceType] || buttonTypo.sizes?.mobile || 14;

    const getStyles = () => {
        const baseStyles = {
            width: '100%',
            height: '100%',
            border: 'none',
            borderRadius: 6,
            fontFamily: buttonTypo.fontFamily || 'Inter, system-ui, sans-serif',
            fontSize: fontSize,
            fontWeight: buttonTypo.weight || 500,
            cursor: disabled ? 'not-allowed' : 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            transition: 'all 0.2s ease',
            opacity: state === 'loading' ? 0.7 : disabled ? 0.5 : 1
        };

        switch (variant) {
            case 'primary':
                return {
                    ...baseStyles,
                    background: primaryColor,
                    color: '#ffffff'
                };
            case 'secondary':
                return {
                    ...baseStyles,
                    background: 'transparent',
                    color: primaryColor,
                    border: `1px solid ${primaryColor}`
                };
            case 'ghost':
                return {
                    ...baseStyles,
                    background: 'transparent',
                    color: '#c9d1d9'
                };
            default:
                return {
                    ...baseStyles,
                    background: primaryColor,
                    color: '#ffffff'
                };
        }
    };

    if (state === 'loading') {
        return (
            <div style={getStyles()}>
                <div style={{
                    width: 16,
                    height: 16,
                    border: '2px solid transparent',
                    borderTopColor: '#ffffff',
                    borderRadius: '50%',
                    animation: 'spin 1s linear infinite'
                }} />
            </div>
        );
    }

    return (
        <div style={getStyles()}>
            {label}
        </div>
    );
};

export default UIButton;
